<template>
  <div class="list-group-item header d-flex justify-content-between align-items-center">
    Songs
    <button class="btn sort-toggle" @click="toggleSort" :title="sortToggleTitle">
      <font-awesome-icon :icon="sortByClass"/>
    </button>
  </div>
  <div
    v-for="song in sortedSongs"
    :key="song.id"
    class="list-group-item indent-1"
    :class="{ selected: isSelected(song) }"
  >
    <div v-if="isSelected(song)" class="flex-grow-1">{{ truncate(song.name, 20) }}</div>
    <router-link v-else :to="`${urlPrefix}/songs/${song.id}`" class="flex-grow-1">{{ truncate(song.name, 20) }}</router-link>
    <div v-if="song.incomplete_note_count > 0" class="incomplete-note-count">
      <div>{{ song.incomplete_note_count }}</div>
    </div>
  </div>
</template>
<style scoped>
.sort-toggle {
  color: white;
}
</style>

<script>
export default {
  props: {
    songs: { type: Array, default: () => [] },
    urlPrefix: { type: String, default: '' },
  },
  data() {
    return { sortBy: 'alpha' }
  },
  computed: {
    sortedSongs() {
      if (this.sortBy === 'alpha') {
        return [...this.songs].sort((a, b) => a.name.localeCompare(b.name))
      } else {
        return [...this.songs].sort((a, b) => {
          const ta = new Date(a.last_mix_uploaded_at).getTime()
          const tb = new Date(b.last_mix_uploaded_at).getTime()
          return tb - ta
        })
      }
    },
    sortToggleTitle() {
      return this.sortBy === 'alpha' ? 'Switch to sort by last upload' : 'Switch to sort alphabetically'
    },
    sortByClass() {
      return this.sortBy === 'recent' ? "sort-alpha-down" : "clock"
    }
  },
  methods: {
    toggleSort() {
      this.sortBy = this.sortBy === 'alpha' ? 'recent' : 'alpha'
    },
    isSelected(song) {
      return this.$route?.path === `/songs/${song.id}` || this.$route?.path === `/shared/songs/${song.id}`
    },
    truncate(str, length) {
      if (!str) return ''
      if (str.length <= length) return str
      return str.slice(0, length - 3) + '...'
    }
  }
}
</script>
